<div class="flex">
  <div class="flex items-center">
    <div>
      <label>{{itemList.length}} 筆</label>
    </div>
    <button class="btn" matSuffix mat-icon-button (click)="onFirstRow()" matTooltip="第一筆">
      <mat-icon>first_page</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onPreviousRow()" matTooltip="上一筆">
      <mat-icon>navigate_before</mat-icon>
    </button>
    <button class="jk-button-small" matSuffix mat-icon-button (click)="doShowInfo($event)">
      <mat-icon>more_vert</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onNextRow()" matTooltip="下一筆">
      <mat-icon>navigate_next</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onLastRow()" matTooltip="最後一筆">
      <mat-icon>last_page</mat-icon>
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="gridHeightChange(20)" matTooltip="表格增高">
      🔎
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="gridHeightChange(-20)" matTooltip="表格縮小">
      🤏
    </button>
    <button class="btn" matSuffix mat-icon-button (click)="onSumAll()" matTooltip="總計">
      <mat-icon>summarize</mat-icon>
    </button>
  </div>
  <div class="flex">
    <app-jkedit [width]="40" placeholder="快搜" [showClearButton]="false" [(value)]="gridSearchValue">
    </app-jkedit>
    <button class="btn" [class.btn-secondary]="true" (click)="searchGrid(gridSearchValue)">
      <mat-icon fontIcon="search" slot="start" name="search-circle-outline"></mat-icon>
    </button>
    <app-jkedit [width]="40" placeholder="快篩,其中包含..." [showClearButton]="false" [(value)]="gridFilterValue"
      (valueChange)="onFilterTextBoxChanged($event)">
    </app-jkedit>
  </div>
</div>



<div class="w-full" [cdkContextMenuTriggerFor]="context_menu">

  <ag-grid-angular #myGrid [theme]="gridSrv.theme" [ngStyle]="gridStyle" [columnDefs]="columnDefs"
    [columnTypes]="gridSrv.columnTypes" [defaultColDef]="gridSrv.defaultColDef" [localeText]="gridSrv.localeText"
    [pagination]="gridSrv.pagination" [paginationPageSize]="gridSrv.paginationPageSize"
    [paginationPageSizeSelector]="gridSrv.paginationPageSizeSelector" [rowSelection]="gridSrv.rowSelection"
    [rowData]="itemList" (gridReady)="onGridReady($event)" (keydown)="onKeydown($event)"
    (rowClicked)="onRowClicked($event)" (rowDoubleClicked)="onRowDoubleClicked($event)" [enableBrowserTooltips]="true"
    (cellValueChanged)="onCellValueChanged($event)" (rowSelected)="onRowSelected($event)"
    (onSelectionChanged)="onSelectionChanged()" [editType]="'fullRow'" (rowEditingStarted)="onRowEditingStarted($event)"
    (rowEditingStopped)="onRowEditingStopped($event)">
  </ag-grid-angular>
</div>

<ng-template #context_menu>
  <div class="jk-menu" cdkMenu>
    @if(isJkaggrid){
    <button class="jk-menu-item" cdkMenuItem (click)="doUIEdit()">修改</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doUIInsert()">新增</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doUIDelete()">刪除</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doSetup()">管理員設定</button>

    }
    <button class="jk-menu-item" cdkMenuItem (click)="doFilter('')">過濾條件</button>
    <button class="jk-menu-item" cdkMenuItem (click)="reloadGrid()">重新整理</button>
    <button class="jk-menu-item" cdkMenuItem>取消功能表</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doItemList()">資料內容(json)</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doMyExportExcel(itemList)">匯出Excel(xlsx)</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doSaveTitle(columnDefs)">存欄位設定</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doResetTitle()">重置欄位設定</button>
    <button class="jk-menu-item" cdkMenuItem (click)="gridSrv.doShowManagerField(columnDefs)">顯示管理欄位</button>
    <button class="jk-menu-item" cdkMenuItem (click)="doShowInfo($event)">表格資訊</button>
  </div>
</ng-template>

<!-- (rowDoubleClicked)="onRowDoubleClicked($event as any)" (afterGridReady)="afterGridReady($event) -->
<!--     <app-jkgridwin #jkgridwin id="jkgridwin" [width]="screenWidth" [defaultHeight]="500"  (rowClicked)="onRowClicked($event)"
      >
    </app-jkgridwin>
 -->
@if (showAdvanced()) {
<mat-toolbar class="mat-toolbar-flex bg-blue-300 border-solid">
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doFilter('')">過濾條件</button>
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doUIInsert()">新增</button>
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doUIDelete()">刪除</button>
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="reloadGrid()">重新整理</button>
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="showSelectedItem()">秀選取資料</button>
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="showAllItems()">秀全部資料</button>
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doUIGridEdit()">grid編輯</button>
  <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doEditAndSave()">grid存檔</button>
  <!-- <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="onBtnExport()">匯出CSV</button>
    <button mat-flat-button color="primary" (click)="doExportExcel()">匯出Excel(xlsx)</button> -->
  <mat-select [(ngModel)]="bookTypeItem" matTooltip="格式" placeholder="匯出格式">
    @for(idNameItem of bookTypeList; track idNameItem) {
    <mat-option [value]="idNameItem">{{idNameItem.name}}</mat-option>
    }
  </mat-select>

</mat-toolbar>
}
<!-- @if(seekPanelVisible){
<mat-toolbar>
  <app-jkedit [visible]="true" [label]="'過濾資料:'" [(value)]="searchValue" [width]="50"
    (valueChange)="quickFilter(searchValue)" placeholder="離開後自動過濾" [styleDisplay]="'flex'">
  </app-jkedit>
  <app-jkedit [visible]="true" [label]="'搜尋:'" [(value)]="targetId" [width]="80" [styleDisplay]="'flex'"
    placeholder="輸入完整欄位資料後按放大鏡">
  </app-jkedit>
  <button class="btn" [class.btn-warning]="true" (click)="seek(targetId,seekFields)">
    <mat-icon fontIcon="search" slot="start" name="search-circle-outline"></mat-icon>
  </button>
</mat-toolbar>

} -->
